<template>
  <v-container fluid>
    <v-row class="mx-2">
      <v-col cols="12" sm="7">
        <v-text-field v-model="search" prepend-inner-icon="search" label="Search Groups"></v-text-field>
      </v-col>
      <v-col cols="12" sm="5">
        <v-checkbox v-model="showActiveGroupsOnly" label="Show active groups only"></v-checkbox>
      </v-col>
    </v-row>
    <v-data-table :search="search" :headers="headers" :items="filterGroups" class="background">
      <template v-slot:item.is_active="{ item }">
        <v-switch
          @change="handleToggle(item)"
          inset
          :label="item.is_active?'Active': 'Inactive'"
          v-model="item.is_active"
        ></v-switch>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { LocationAPI } from '@/clients/locations/locations.api'
import { LocationGroupAPI } from '../../../clients/locationGroups/locationGroups.api'
export default {
  mounted() {
    this.getLocationWithGroups()
  },
  data() {
    return {
      showActiveGroupsOnly: true,
      location: null,
      search: '',
      headers: [{
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Description',
        value: 'description'
      }, {
        text: 'Active',
        value: 'is_active'
      }]
    }
  },
  methods: {
    async getLocationWithGroups() {
      let response
      try {
        response = await LocationAPI.getLocationById(this.$route.params['id'], { groups: true })
      } catch (error) {
        return console.log(error)
      }
      this.location = response.data.payload
    },
    async addLocationToGroup(group) {
      try {
        await LocationGroupAPI.addLocationToGroup(group.id, this.$route.params.id)
      } catch (error) {
        location.is_active = !location.is_active
        return console.log(error)
      }
      this.snackbar({ text: 'Location has been added to the group', color: 'success', icon: 'check' })
    },
    async removeLocationFromGroup(group) {
      try {
        await LocationGroupAPI.removeLocationFromAGroup(group.id, this.$route.params.id)
      } catch (error) {
        location.is_active = !location.is_active
        return console.log(error)
      }
      this.snackbar({ text: 'Location has been removed from group', color: 'warning darken-1' })
    },
    handleToggle(group) {
      if (group.is_active) {
        this.addLocationToGroup(group)
      } else {
        this.removeLocationFromGroup(group)
      }
    }
  },
  computed: {
    filterGroups() {
      if (this.location === null) return []
      if (this.showActiveGroupsOnly) {
        return this.location.location_groups.filter(i => i.is_active === true)
      }
      return this.location.location_groups
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
